module.exports = __webpack_public_path__ + "static/media/nfl2019.0cb47c75.jpg";